(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-intake-form]');
    if (!form) return;
    const status = root.querySelector('[data-intake-status]');
    const error = root.querySelector('[data-intake-error]');
    const fields = root.querySelector('[data-intake-fields]');
    const result = root.querySelector('[data-intake-result]');
    const refresh = root.querySelector('[data-intake-refresh]');
    const base = root.dataset.endpoint;
    if (!/^\/apps\/[a-z0-9_-]+$/.test(base) || !root.dataset.termsUrl) {
      status.textContent = 'Servicebokningen är inte tillgänglig. Kontakta oss för hjälp.';
      return;
    }
    let token;
    let requestId;
    let busy = false;
    const storageKey = 'radne-service-intake';
    async function api(path, options = {}) {
      const response = await fetch(base + path, { credentials: 'same-origin', ...options });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) {
        const exception = new Error(body.message || (response.status === 429 ? 'För många anrop. Vänta en stund och försök igen.' : 'Tjänsten svarade med HTTP ' + response.status + '. Kontakta oss för hjälp.'));
        exception.status = response.status;
        throw exception;
      }
      return body;
    }
    function showError(message) { error.textContent = message; error.hidden = false; }
    function render(body) {
      form.hidden = true;
      result.hidden = false;
      root.querySelector('[data-intake-number]').textContent = 'Servicenummer: ' + body.number;
      const message = root.querySelector('[data-intake-result-message]');
      const downloads = root.querySelector('[data-intake-downloads]');
      downloads.hidden = !body.documentsReady;
      root.querySelector('[data-intake-new]').hidden = !body.documentsReady;
      refresh.hidden = (body.documentsReady && body.emailStatus === 'Queued') || body.state === 'NeedsReview';
      if (body.documentsReady) {
        message.textContent = (body.isTest ? 'TEST – provetiketten är inte giltig för frakt. ' : '') +
          'Hämta dokumenten här. ' + (body.emailStatus === 'Queued'
            ? 'Ett mejl med båda PDF-filerna är köat för utskick' + (body.isTest ? ' till testmottagaren.' : ' till din mejladress.')
            : 'Mejlutskicket kunde inte förberedas ännu. Kontrollera status igen eller kontakta oss.');
        root.querySelector('[data-intake-label]').href = base + '/registrations/' + requestId + '/label';
        root.querySelector('[data-intake-note]').href = base + '/registrations/' + requestId + '/service-note';
      } else if (body.state === 'NeedsReview') {
        message.textContent = 'Ditt ärende är registrerat, men frakten behöver kontrolleras av oss. Kontakta oss och ange servicenumret. Gör inte en ny bokning.';
      } else {
        message.textContent = 'Ditt ärende är registrerat och dokumenten förbereds. Kontrollera status om en stund.';
      }
      fields.disabled = true;
      status.textContent = '';
      result.focus();
    }
    async function check() {
      if (busy || !requestId) return;
      busy = true; refresh.disabled = true; error.hidden = true;
      try { render(await api('/registrations/' + requestId)); }
      catch (exception) { showError(exception.message); }
      finally { busy = false; refresh.disabled = false; }
    }
    refresh.addEventListener('click', check);
    root.querySelector('[data-intake-new]').addEventListener('click', () => {
      requestId = undefined;
      try { sessionStorage.removeItem(storageKey); } catch { /* Storage is optional. */ }
      form.reset(); form.hidden = false; fields.disabled = false; result.hidden = true;
      form.elements.name.focus();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const values = Object.fromEntries(new FormData(form));
      requestId ||= crypto.randomUUID();
      // Store only the request ID. Reusing it after a timeout prevents another paid booking.
      try { sessionStorage.setItem(storageKey, requestId); } catch { /* Registration still works without browser storage. */ }
      busy = true; fields.disabled = true; error.hidden = true;
      status.textContent = 'Registrerar ärendet och hämtar fraktsedeln…';
      try {
        render(await api('/registrations', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Service-Form-Token': token },
          body: JSON.stringify({ ...values, requestId, acceptTerms: values.acceptTerms === 'on' })
        }));
      } catch (exception) {
        showError(exception.message + ' Försök igen med samma registrering.');
        status.textContent = ''; fields.disabled = false;
      } finally { busy = false; }
    });
    (async () => {
      try {
        const session = await api('/session');
        token = session.formToken;
        root.querySelector('[data-intake-email]').value = session.email;
        if (!form.elements.name.value) form.elements.name.value = session.name;
        status.textContent = ''; fields.disabled = false;
        try { requestId = sessionStorage.getItem(storageKey); } catch { /* Storage is optional. */ }
        if (requestId && /^[0-9a-f-]{36}$/i.test(requestId)) {
          try { render(await api('/registrations/' + requestId)); }
          catch (exception) {
            if (exception.status === 404) requestId = undefined;
            else { fields.disabled = true; throw exception; }
          }
        }
      } catch (exception) { status.textContent = ''; showError(exception.message); }
    })();
  }
  document.querySelectorAll('[data-service-intake]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-service-intake]').forEach(initialize));
})();
